import {
  Card,
  CircleEmptyPlayIcon,
  Modal,
  Typography,
} from "@codat/orchard-ui";
import { useProduct } from "contexts/ProductsContext";
import { useMatchMedia } from "hooks/useMatchMedia";
import React, { useState } from "react";
import { getProductDetails } from "utils";

import Button from "components/Button";

import styles from "./ProductBanner.module.scss";

interface ProductBannerProps {
  productId: string;
}

const ProductBanner = ({ productId }: ProductBannerProps) => {
  const isSmallDesktop = useMatchMedia("(max-width:1420px)");
  const { product } = useProduct(productId);
  const productDetails = getProductDetails(product);
  const { homePageCopy, Icon, bannerImageHref, videoLinkHref } = productDetails;

  const titleText = product?.name.replace(" V1", "") ?? "Unknown product"; // Remove V1 suffix from titles. TODO: delete once this logic has been moved to the backend

  const [isShowing, setIsShowing] = useState<boolean>(false);

  const handleOnClose = () => {
    setIsShowing(false);
  };

  return (
    <Card className={styles.card} data-testid={`product-banner-${productId}`}>
      <div className={styles.textContainer}>
        <div className={styles.productTitle}>
          <Icon />
          <Typography
            as="h2"
            variant="heading_xl"
            className={styles.header}
            data-testid="banner-header"
          >
            {titleText}
          </Typography>
        </div>
        <Typography as="p" variant={"body_lg"} className={styles.bodyText}>
          {homePageCopy}
        </Typography>
        {videoLinkHref && (
          <div>
            <Button
              data-testid="banner-video-button"
              buttonName="video-button"
              variant="secondary"
              color="white"
              className={styles.videoButton}
              onClick={() => setIsShowing(true)}
              size={isSmallDesktop ? "small" : "medium"}
            >
              <div className={styles.videoButtonContent}>
                <CircleEmptyPlayIcon className={styles.videoIcon} />
                <Typography as="p" variant={"body_lg"}>
                  What is {titleText}?
                </Typography>
              </div>
            </Button>
          </div>
        )}
        {videoLinkHref && isShowing && (
          <Modal
            onClose={handleOnClose}
            size="large"
            data-testid="overview-video"
          >
            <Card size="small">
              <iframe
                width="1180"
                height="600"
                src={videoLinkHref}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Card>
          </Modal>
        )}
      </div>
      <img
        src={bannerImageHref}
        alt={titleText}
        className={styles.integrationLogos}
        data-testid="banner-image"
      />
    </Card>
  );
};

export default ProductBanner;
